import { QueryClient } from '@tanstack/react-query';

// Singleton partagé entre App.tsx (QueryClientProvider) et authStore.ts, qui
// doit pouvoir vider le cache au login/logout/changement de tenant impersonné
// pour ne jamais laisser les données d'une session ou d'un tenant précédent
// s'afficher pour un autre (ex. Settings > Entreprise montrant les infos du
// tenant précédemment consulté).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,          // données fraîches 1 min → pas de refetch inutile
      refetchOnWindowFocus: false, // ne pas refetcher à chaque retour sur l'onglet
      retry: 1,                   // 1 seul retry natif TanStack (l'axios en fait déjà 3)
    },
  },
});
